import { AiOutlineRightCircle } from "react-icons/ai";
import { PropTypes } from 'prop-types';
const WhatYouWillLearn = ({list}) => {
    // const list = [
    //     "Introductory Calculus and Analytic Geometry",
    //     "Chemistry Laboratory",
    //     "Physics 1",
    //     "Islamic Study / Moral Study (Malaysian students)",
    //     "Physics Laboratory 1",
    //     "Campus Life Skills",
    //     "Foundation English",
    //     "Physics II",
    //     "Chemistry 1",
    //     "Physics Laboratory II",
    //     "Chemistry II",
    //     "Calculus & Analytic Geometry II",
    //     "English for Academic Purposes",
    //     "Computing Skills",

    // ]
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 w-full ">

            {
                list?.map((item, index) => (
                    <div className="flex w-full items-center gap-4 my-2" key={index}>
                        <span className="text-red-500"><AiOutlineRightCircle /></span>
                        <h2 className="text-xl 2xl:text-base text-neutral-500  w-full">{item}</h2>
                    </div>
                ))
            }

        </div>
    )
}
WhatYouWillLearn.propTypes = {
    list: PropTypes.array
}
export default WhatYouWillLearn